import PendingRequestsInterceptor from './interceptors/http.pending.requests.interceptor';
import HttpPendingRequestsConfigurator from './config/http.pending.requests.run';
import HttpPendingService from './services/http.pending.service';

const moduleName = 'app.massia.http-pending';

angular.module(moduleName, []).config(PendingRequestsInterceptor).service('HttpPending', HttpPendingService).run(HttpPendingRequestsConfigurator);

export default moduleName;
